<template>
  <template v-for="(item, index) in menus" :key="index">
    <template v-if="item.children && item.children.length > 0">
      <el-sub-menu :index="index">
        <template #title>
          {{ item.meta.title }}
        </template>
        <sysytemSubMenu :menus="item.children"></sysytemSubMenu>
      </el-sub-menu>
    </template>
    <template v-else>
      <el-menu-item :index="item.path" @click="clickMenuItem(item)">
        <span class="meta-title" :title="item.meta.title">
          {{ item.meta.title }}</span
        >
      </el-menu-item>
    </template>
  </template>
</template>

<script>
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "sysytemSubMenu",
  props: {
    menus: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const router = useRouter();
    const clickMenuItem = (item) => {
      console.log(item, "===========================");
      router.push(item.path);
    };
    return {
      clickMenuItem,
    };
  },
});
</script>
<style lang="less" scoped>
.meta-title {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-emphasis: ellipsis;
}
</style>
